import { render, staticRenderFns } from "./HandleHistory.vue?vue&type=template&id=e049530a&scoped=true"
import script from "./HandleHistory.vue?vue&type=script&lang=js"
export * from "./HandleHistory.vue?vue&type=script&lang=js"
import style0 from "./HandleHistory.vue?vue&type=style&index=0&id=e049530a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e049530a",
  null
  
)

export default component.exports